export const trimStringToLength = (str: string, length = 135) => {
  if (str.length < length) {
    return str
  }

  return `${str.substring(0, length)}...`
}
